import { InjectionToken } from '@angular/core';

export const Calsoft_APP_CONFIG = new InjectionToken<any>('Default configuration for the app');
